import { createOutlet } from './Outlet';
// Returns an outlet that only has a current value when the source outlet has
// a value, *and* when the given predicate returns true.
export function filter(outletDescriptor, predicate) {
    return createOutlet({
        getCurrentValue: outletDescriptor.getCurrentValue,
        hasCurrentValue: function () { return predicate(outletDescriptor.getCurrentValue()); },
        subscribe: outletDescriptor.subscribe,
    });
}
//# sourceMappingURL=filter.js.map